import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { URBANAI_URL } from '../lib/seo';
import skylineBg from '../assets/urbanai-flagship-bg.png';

// Closing CTA band — the one deliberately dark section on an otherwise
// light page, for visual punctuation at the end of the scroll. The
// background photo's own baked-in text/logo is overlaid into illegibility
// by the gradient scrim; our own copy renders on top of that.
export default function GetInTouchSection() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 9, md: 13 },
        position: 'relative',
        overflow: 'hidden',
        backgroundImage: `linear-gradient(165deg, rgba(10,8,7,0.68), rgba(20,14,11,0.82)), url(${skylineBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', textAlign: 'center' }}>
        <Typography
          sx={{
            fontFamily: 'var(--font-mono)',
            fontSize: '0.72rem',
            textTransform: 'uppercase',
            letterSpacing: '0.14em',
            color: 'rgba(245,243,238,0.72)',
            mb: 2
          }}
        >
          {t('home.getInTouch.eyebrow')}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontFamily: 'var(--font-serif)',
            fontSize: { xs: '2.4rem', md: '3.8rem' },
            lineHeight: 1.04,
            letterSpacing: '-0.02em',
            mb: 2,
            color: '#F5F3EE'
          }}
        >
          {t('home.getInTouch.title')}
        </Typography>
        <Typography sx={{ color: 'rgba(245,243,238,0.78)', maxWidth: 560, mx: 'auto', mb: 4 }}>
          {t('home.getInTouch.subtitle')}
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            component={RouterLink}
            to="/contact"
            size="large"
            variant="contained"
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              bgcolor: '#F5F3EE',
              color: '#141413',
              borderRadius: 999,
              '&:hover': { bgcolor: '#F5F3EE', opacity: 0.9 }
            }}
          >
            {t('home.getInTouch.cta')}
          </Button>
          <Button
            component="a"
            href={URBANAI_URL}
            target="_blank"
            rel="noopener noreferrer"
            size="large"
            variant="outlined"
            sx={{
              borderRadius: 999,
              borderColor: 'rgba(245,243,238,0.4)',
              color: '#F5F3EE',
              '&:hover': { borderColor: '#F5F3EE', bgcolor: 'rgba(245,243,238,0.08)' }
            }}
          >
            {t('home.getInTouch.ctaSecondary')}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
